import React from "react";
import Courses from "../components/otherPageComponent/courses";
import SEO from "../components/SEO";

function CoursesPage() {
  return (
    <>
      <SEO
        title="Courses - Aastha Computers"
        description="Explore the diverse computer courses at Aastha Computes, Bikaner. From basic computer skills to advanced programming and software training, find the perfect course for your learning goals."
        pagePath="/contact"
      />
      <Courses />
    </>
  );
}

export default CoursesPage;
